// src/pages/Welcome/TrustSection.jsx
import React from 'react';
import { COLORS, TYPOGRAPHY, LAYOUT } from '../../constants';
import { EmailIcon, SearchIcon, LocationIcon, CreditCardIcon } from '../../components/Icons';

const TrustSection = () => {
  const processSteps = [
    {
      id: 1,
      icon: EmailIcon,
      title: "Sign Up with ISU Email",
      description: "Verify your @ilstu.edu email address to join the exclusive ISU marketplace community.",
      step: "Step 1"
    },
    {
      id: 2,
      icon: SearchIcon,
      title: "Browse & Connect",
      description: "Search through listings from fellow Redbirds and connect directly with sellers.",
      step: "Step 2"
    },
    {
      id: 3,
      icon: LocationIcon,
      title: "Meet on Campus",
      description: "Arrange safe meetups in public campus locations like the Bone Student Center or Milner Library.",
      step: "Step 3"
    },
    {
      id: 4,
      icon: CreditCardIcon,
      title: "Complete Transaction",
      description: "Pay securely our integrated Stripe payment system.",
      step: "Step 4"
    }
  ];

  const sectionStyle = {
    padding: `${LAYOUT.spacing.section} ${LAYOUT.spacing.lg}`,
    backgroundColor: COLORS.white,
    position: 'relative',
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: LAYOUT.spacing.xxl,
  };

  const titleStyle = {
    ...TYPOGRAPHY.h2,
    color: COLORS.text.primary,
    marginBottom: LAYOUT.spacing.sm,
    fontSize: 'clamp(2rem, 4vw, 2.5rem)',
    fontWeight: '700',
  };

  const subtitleStyle = {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: 'clamp(1.1rem, 2vw, 1.25rem)',
    maxWidth: '600px',
    margin: '0 auto',
    lineHeight: '1.6',
  };

  const stepsContainerStyle = {
    position: 'relative',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '0 40px',
  };

  const connectingLineStyle = {
    position: 'absolute',
    left: '70px',
    top: '80px',
    height: 'calc(100% - 160px)',
    width: '2px',
    backgroundColor: COLORS.primary + '20',
    zIndex: 1,
  };

  const stepStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: LAYOUT.spacing.xxxl,
    gap: LAYOUT.spacing.lg,
    position: 'relative',
    zIndex: 2,
  };

  const stepNumberStyle = {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    fontWeight: '700',
    flexShrink: 0,
    boxShadow: `0 4px 16px ${COLORS.shadow}`,
    border: `3px solid ${COLORS.white}`,
  };

  const stepContentStyle = {
    flex: 1,
    paddingTop: '8px',
  };

  const iconContainerStyle = {
    width: '48px',
    height: '48px',
    borderRadius: LAYOUT.borderRadius.lg,
    backgroundColor: COLORS.primary + '15',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: LAYOUT.spacing.sm,
  };

  const featureTitleStyle = {
    ...TYPOGRAPHY.h4,
    color: COLORS.text.primary,
    fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
    fontWeight: '600',
    marginBottom: LAYOUT.spacing.md,
  };

  const featureDescriptionStyle = {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: '16px',
    lineHeight: '1.6',
    maxWidth: '300px',
    margin: '0 auto',
  };

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>How It Works</h2>
          <p style={subtitleStyle}>
            Getting started on Redbird Markets is simple and secure. Follow these easy steps to join your campus community.
          </p>
        </div>

        <div style={stepsContainerStyle}>
          {/* Connecting line */}
          <div style={connectingLineStyle} />
          
          {processSteps.map((step, index) => {
            const IconComponent = step.icon;
            
            return (
              <div key={step.id} style={stepStyle}>
                <div style={stepNumberStyle}>
                  {index + 1}
                </div>
                
                <div style={stepContentStyle}>
                  <div style={iconContainerStyle}>
                    <IconComponent size={24} color={COLORS.primary} />
                  </div>
                  
                  <h3 style={{
                    ...featureTitleStyle,
                    marginBottom: LAYOUT.spacing.sm,
                    textAlign: 'left',
                  }}>
                    {step.title}
                  </h3>
                  
                  <p style={{
                    ...featureDescriptionStyle,
                    maxWidth: '400px',
                    margin: 0,
                    textAlign: 'left',
                  }}>
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;